<template>
    <div>
        <b-form class="step-form" @submit.stop.prevent="onSubmit">
            <div class="row">
                <div class="col-lg-12">
                    <h3>Upload Identity Documents</h3>
                </div>
                <div class="col-lg-12">
                    <div class="row form-options">
                        <div class="col-md-5">
                            <identity-type
                                :data-segment-id="dataSegmentId"
                                :disabled="true"
                            ></identity-type>
                        </div>
                        <div class="col-md-7">
                            <cropper
                                ref="cropper"
                                :data-segment-id="dataSegmentId"
                            ></cropper>
                        </div>
                        <div class="col-lg-6">
                            <cropper-back
                                ref="cropper"
                                :data-segment-id="dataSegmentId"
                            ></cropper-back>
                            <!-- <utility-bill :field="fieldCNICBack"></utility-bill> -->
                        </div>
                        <div class="col-lg-6"></div>
                        <div class="col-lg-6">
                            <base-button
                                btn-type="submit"
                                btn-variant="primary"
                                btn-label="CONTINUE"
                                :class="loading ? 'disabled' : ''"
                                :disabled="loading"
                            ></base-button>
                        </div>

                        <!-- <div class="col-lg-6">
                        <signature ref="signature"></signature>
                    </div> -->
                    </div>
                </div>
                <div class="col-lg-4"></div>
            </div>
        </b-form>
        <b-modal
            ref="requireddocument"
            size="lg"
            title="Required Documents"
            hide-footer
            :click-to-close="false"
            :no-close-on-backdrop="true"
            :no-close-on-esc="true"
        >
            <required-documents-popup></required-documents-popup>
        </b-modal>
    </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import request from '@/utils/request'
import _ from 'lodash'

import IdentityType from '@/components/registration/IdentityType.vue'
// import IdentityDocument from '@/components/registration/IdentityDocument.vue'
import UtilityBill from '@/components/registration/UtilityBill.vue'
import Cropper from '@/components/registration/Cropper.vue'
import CropperBack from '@/components/registration/CropperBack.vue'
import RequiredDocumentsPopup from '@/components/registration/RequiredDocumentsPopup.vue'
// import Signature from '@/components/registration/Signature.vue'
import resource from '@/api/resource'
const viewBrandingApi = new resource('configurations/branding')
import JSZip from 'jszip'

export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        IdentityType,
        // IdentityDocument,
        UtilityBill,
        Cropper,
        RequiredDocumentsPopup,
        CropperBack,
        // Disclaimer,
        // VueCroppie,
    }, // End of Component > components

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        dataForm: {
            type: Object,
            required: true,
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            soundeffect: new Audio(),
            fieldCNICBack: {
                isRequired: true,
                isLocked: true,
                key: 'documentInfo.cnicBack.fileName',
                originalFileNameKey: 'documentInfo.cnicBack.originalFileName',
                keyBackEnd: 'cnicBack',
                label: 'Id Document BACK SCAN COPY',
                urduLabel: 'شناختی دستاویز کی بیک اسکین کاپی',
                vvName: 'Id Document BACK scan copy',
            },
            ssaForms: {
                form1: {
                    valid: false,
                    routeName: 'identity-document',
                    name: 'Identity Document',
                },
                form2: {
                    valid: false,
                    routeName: 'setup-profile',
                    name: 'Setup Profile',
                },

                // form3: {
                //     valid: false,
                //     routeName: 'additional-info',
                //     name: 'Additional Info',
                // },
                form3: {
                    valid: false,
                    routeName: 'kyc',
                    name: 'KYC',
                },
                form4: {
                    valid: false,
                    routeName: 'investment',
                    name: 'Investment',
                },

                form5: {
                    valid: false,
                    routeName: 'risk-product',
                    name: 'Risk Product',
                },

                form6: {
                    valid: false,
                    routeName: 'upload-document',
                    name: 'Upload Document',
                },
            },
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapState({
            userOcr: (state) => state.registration.useOcr,
        }),

        ...mapGetters(['dataSegmentId', 'loading', 'form']),

        dataSegmentId() {
            if (this.$route.params.dataSegmentId) {
                return this.$route.params.dataSegmentId
            }
            return this.$store.getters.dataSegmentId
        },

        // isIdle() {
        //     console.log("idle-state: "+this.$store.state.idleVue.isIdle)
        //     return this.$store.state.idleVue.isIdle;
        // },
    }, // End of Component > computed

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */

    watch: {
        /**
         * Handle when the file is uploaded successfully
         *
         * @return {void}
         */
        async 'form.documentInfo.identity.fileName'(value) {
            // check if the value is not empty
            // and perform action accordintly
            // if (this.userOcr && value !== null && value !== undefined) {
            try {
                const formData = new FormData()
                formData.append(
                    'filePath',
                    `${process.env.VUE_APP_API_URL}files/customers/${value}`
                )
                formData.append('type', 'id')

                const headers = {
                    'Content-Type': 'multipart/form-data',
                }
                const { data } = await request.post('ocr/', formData, {
                    headers,
                })

                debugger
                if (
                    [
                        'identity-document',
                        'upload-document',
                        'record-video',
                        'public-registration-identity-document',
                    ].includes(this.$route.name.toString())
                ) {
                    this.$store.commit('updateField', {
                        key: 'identityInfo.number',
                        value: data.customer_data.idnumber.replace(/-/g, ''),
                    })

                    this.$store.commit('updateField', {
                        key: 'identityInfo.expiryDate',
                        value: this.$moment(
                            data.customer_data.dateofexpiry,
                            'D-M-Y'
                        ).isValid()
                            ? this.$moment(
                                  data.customer_data.dateofexpiry,
                                  'D-M-Y'
                              ).format('YYYY-MM-DD')
                            : '',
                    })

                    this.$store.commit('updateField', {
                        key: 'identityInfo.IssuanceDate',
                        value: this.$moment(
                            data.customer_data.dateofissue,
                            'D-M-Y'
                        ).isValid()
                            ? this.$moment(
                                  data.customer_data.dateofissue,
                                  'D-M-Y'
                              ).format('YYYY-MM-DD')
                            : '',
                    })

                    let fullName = _.split(data.customer_data.name, ' ')

                    let firstName = fullName.shift()
                    let lastName = fullName.pop()
                    let middleName = fullName.join(' ')

                    this.$store.commit('updateField', {
                        key: 'basicInfo.firstName',
                        value: firstName + ' ' + middleName + ' ' + lastName,
                    })

                    this.$store.commit('updateField', {
                        key: 'basicInfo.middleName',
                        value: ' ',
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.lastName',
                        value: ' ',
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.dateOfBirth',
                        value: this.$moment(
                            data.customer_data.dob,
                            'D-M-Y'
                        ).isValid()
                            ? this.$moment(
                                  data.customer_data.dob,
                                  'D-M-Y'
                              ).format('YYYY-MM-DD')
                            : '',
                    })

                    this.$store.commit('updateField', {
                        key: 'basicInfo.fatherOrHusbandName',
                        value: data.customer_data.fathername,
                    })
                }
            } catch (error) {
                // console.log(error)
            }
            this.$store.commit('setLoading', false)
            // }
        }, // End of user() method
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        window.fbq('track', 'PageView')
        this.$store.dispatch('trackEvent', {
            event: 'JS | SSA Register ID document upload',
        })
        this.getBrandingData()
        this.soundon()
        if (!this.$store.getters.getField('ssaForms.form1.valid')) {
            this.$store.commit('updateField', {
                key: 'ssaForms',
                value: this.ssaForms,
            })
        }

        // console.log('this.$store.state.form.forms',
        //             JSON.stringify(this.$store.state.registration.form.ssaForms))
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getBrandingData() {
            let { data } = await viewBrandingApi.list()
            this.$store.commit('setDisplaySetting', data.data)
        },
        /**
         * Handle when the form has been submitted
         *
         * @return {void}
         */
        async onSubmit() {
            // this.download_btn()
            // validate the form fields
            const result = await this.$validator.validateAll()
            // Check if validation fails
            if (result) {
                // this.$store.commit('setLoading', true)

                this.$store.commit('updateField', {
                    key: 'ssaForms.form1.valid',
                    value: true,
                })

                // console.log(
                //     'Form 1 is valid ? ' +
                //         this.$store.getters.getField('forms.form1.valid')
                // )

                // this.soundon();
                if (this.$route.meta.publicRegistration === true) {
                    this.$router.push({
                        name: 'public-registration-record-video-ssa',
                        // name: 'public-registration-setup-profile-ssa',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                        },
                    })
                } else {
                    // this.$router.push('/register-customer/record-video')
                    // this.$router.push('/register-customer/upload-document')
                    this.$router.push('/ssa-customer/setup-profile')
                }
            } else {
                this.$store.commit('updateField', {
                    key: 'ssaForms.form1.valid',
                    value: false,
                })
                this.$store.commit('setError', this.errors.all()[0])
            }
        }, // End of onSubmit() method
        soundon() {
            const sound =
                'data:audio/mpeg;base64,SUQzBAAAAAABEVRYWFgAAAAtAAADY29tbWVudABCaWdTb3VuZEJhbmsuY29tIC8gTGFTb25vdGhlcXVlLm9yZwBURU5DAAAAHQAAA1N3aXRjaCBQbHVzIMKpIE5DSCBTb2Z0d2FyZQBUSVQyAAAABgAAAzIyMzUAVFNTRQAAAA8AAANMYXZmNTcuODMuMTAwAAAAAAAAAAAAAAD/80DEAAAAA0gAAAAATEFNRTMuMTAwVVVVVVVVVVVVVUxBTUUzLjEwMFVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQsRbAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVf/zQMSkAAADSAAAAABVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVVV'
            this.soundeffect.src = sound
            this.$store.commit('updateField', {
                key: 'soundSrc',
                value: this.soundeffect,
            })
        },
    }, // End of Component > mounted
} // End of export default
</script>
